<template>
  <div class="add-unit">
    <Card>
      <h2 v-if="!unitInfo.id" style="text-align: center;margin:20px 0 0 0;">新增单位通讯录</h2>
      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改单位通讯录</h2>
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="值班电话" prop="dutyTelephone">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写值班电话"></Input>
          </FormItem>
          <FormItem label="传真电话" prop="faxPhone">
            <Input v-model="formValidate.faxPhone" placeholder="请填写传真电话"></Input>
          </FormItem>
          <FormItem label="单位" prop="unitId">
            <TreeSelect v-model="formValidate.unitId" placeholder="请选择单位" class="treeSelect" transfer clearable
                        :data="unitList"/>
          </FormItem>
          <!--          <FormItem>-->
          <!--            <Button v-if="!unitInfo.id" type="primary" @click="handleSubmit('formValidate')">新增</Button>-->
          <!--            <Button v-if="unitInfo.id" type="primary" @click="editUnit('formValidate')">编辑</Button>-->
          <!--            <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>-->
          <!--          </FormItem>-->
        </Form>
        <div style="text-align: center">
          <Button v-if="!unitInfo.id" type="primary" :loading="saveLoading" @click="handleSubmit('formValidate')">新增
          </Button>
          <Button v-if="unitInfo.id" type="primary" :loading="saveLoading" @click="editUnit('formValidate')">编辑
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          <Button @click="goBack" type="primary" style="margin-left: 8px">返回</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "addUnitPhone",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('必填'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) { // 判断用户输入的值是否符合规则
        callback(new Error('请输入正确的11位手机号码'))
      } else {
        callback()
      }
    }
    return {
      saveLoading: false,
      unitList: [],
      unitInfo: {},
      formValidate: {
        unitId: '',
        faxPhone: '',
        dutyTelephone: ''
      },
      ruleValidate: {
        unitId: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        faxPhone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        dutyTelephone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.getAllUnit()
    if (this.$route.params.row) {
      this.unitInfo = this.$route.params.row.workAddressBook
      this.formValidate = this.unitInfo
    }
  },
  methods: {
    goBack(){
      // 跳转关闭当前页
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'unitList'
      })
    },
    getAllUnit() {
      this.$http.get('/api/unit/getAll').then(res => {
        // console.log(res)
        this.unitList = res.data.data
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          this.$http.post('/api/wab/workAddressBooks', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('新增完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'unitList'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editUnit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$http.put('/api/wab/workAddressBooks', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('修改完成！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'unitList'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.add-unit {
  .treeSelect {
    width: 200px;
  }
}
</style>
